import { render, staticRenderFns } from "./payslip.vue?vue&type=template&id=ec729e2e&scoped=true"
import script from "./payslip.vue?vue&type=script&lang=js"
export * from "./payslip.vue?vue&type=script&lang=js"
import style0 from "./payslip.vue?vue&type=style&index=0&id=ec729e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec729e2e",
  null
  
)

export default component.exports